var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "cost-unit-draft-detail-modal",
            "hide-footer": "",
            size: "xl",
            title: "Details Schadenpositionsentwurf",
            visible: _vm.isModalOpen,
          },
          on: {
            hide: function ($event) {
              return _vm.reset()
            },
            show: _vm.loadCostUnitDraft,
          },
        },
        [
          _vm.isLoading
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-center pt-1" },
                [_c("csp-loading-indicator")],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "b-card",
                    { staticClass: "mb-4 info-card" },
                    [
                      _c(
                        "b-row",
                        [
                          _vm._l(_vm.costUnitDraft, function (value, key) {
                            return _c(
                              "b-col",
                              { key: key, attrs: { cols: "4" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "info-card-element" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.labels[key] || key) +
                                          "\n                            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.formatters[key]
                                              ? _vm.formatters[key](value)
                                              : value
                                          ) +
                                          "\n                            "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "4" } }, [
                            _c("div", { staticClass: "info-card-element" }, [
                              _c("label", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.labels["hide"] || "hide") +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "value" },
                                [
                                  _c("csp-hide-for-group", {
                                    attrs: {
                                      "default-value": _vm.hideForGroupValues,
                                      options: _vm.hideForGroupOptions,
                                      "record-id": _vm.recordId,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }